import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import DiffItem from './DiffItem'
import Slider from 'react-slick'

const filters = [
  {
    name: 'All',
    values: ['*']
  },
  {
    name: 'Lymphocytes',
    values: ['wbc_m', 'wbc_m_l']
  },
  {
    name: 'Abnormal Lymphocytes',
    values: ['wbc_m_l_ab']
  },
  {
    name: 'Platelet Aggregates',
    values: ['plt_agg']
  },
  {
    name: 'Nucleated RBCs',
    values: ['nrbc']
  },
  {
    name: 'Monocytes',
    values: ['wbc_m_m']
  },
  {
    name: 'Neutrophils',
    values: ['wbc_p', 'wbc_p_n']
  },
  {
    name: 'Eosinophils',
    values: ['wbc_p_e']
  },
  {
    name: 'Unknown',
    values: ['wbc']
  },
  {
    name: 'wbc_u',
    values: ['wbc_u']
  }
]

class DiffView extends React.Component {
  static defaultProps = {
    onUpdateKeypoint: _.noop,
    image: '',
    keypoints: [],
    width: 2048
  }

  static propTypes = {
    onUpdateKeypoint: PropTypes.func,
    imageObjects: PropTypes.arrayOf(PropTypes.shape({
      raw: PropTypes.string
    })),
    width: PropTypes.number
  }

  constructor (props) {
    super(props)
    this.state = {
      cellFilter: filters[0],
      onlyCenter: false,
      slideMode: false
    }
    this.slider = null
  }

  setFilter = (filter) => {
    this.setState({
      cellFilter: filter
    })
  }

  toggleCenter = () => {
    this.setState({
      onlyCenter: !this.state.onlyCenter
    })
  }

  toggleSlideMode = () => {
    this.setState({
      slideMode: !this.state.slideMode
    })
  }

  onUpdateKeypoint = (...args) => {
    return this.props.onUpdateKeypoint(...args)
    .then(() => {
      this.slider.slickNext()
    })
  }

  afterChange = (event, slick, currentSlide) => {
    document.getElementsByClassName('slick-current')[0].querySelector('.container').focus()
  }

  render () {
    const { cellFilter, onlyCenter, slideMode } = this.state
    const { imageObjects, width } = this.props
    const height = 0.75 * width
    const diffRows = _.flatten(_.map(imageObjects, (image, index) => {
      const filteredKeypoints = _.filter(image.keypoints.true, (keypoint) => {
        const distance = Math.sqrt(Math.pow(keypoint.x - width / 2, 2) + Math.pow(keypoint.y - height / 2, 2))
        return (_.some(cellFilter.values, (value) => keypoint.note === value) || (cellFilter.name === 'All')) &&
          (!onlyCenter || (
            distance < 1200
          ))
      })
      return _.map(filteredKeypoints, (key, index) => (
        <div>
          <DiffItem
            key={key.x + key.y + key.note + index}
            image={image.raw}
            keypoint={key}
            width={width}
            onUpdateKeypoint={this.onUpdateKeypoint}
          />
        </div>
      ))
    }))

    let imagesView = null

    if (slideMode) {
      const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: true,
        dots: true,
        afterChange: this.afterChange,
        appendDots: (dots) => <ul style={{ top: '80vh' }}>{dots}</ul>
      }
      imagesView = (
        <Slider
          {...settings}
          ref={c => this.slider = c}
        >
          {diffRows}
        </Slider>
      )
    } else {
      imagesView = diffRows
    }


    return (
      <div>
        <ul className='nav nav-pills' style={{ marginBottom: '15px' }}>
          <li
            className='nav-item'
          >
            <a className={`clickable nav-link ${onlyCenter ? 'active' : ''}`} onClick={() => this.toggleCenter()}>Center Only</a>
          </li>
          <li
            className='nav-item'
          >
            <a className={`clickable nav-link ${slideMode ? 'active' : ''}`} onClick={() => this.toggleSlideMode()}>Slide Mode</a>
          </li>
        </ul>
        <ul className='nav nav-pills' style={{ marginBottom: '15px' }}>
          {_.map(filters, (potentialFilter) => (
            <li
              className='nav-item'
              key={potentialFilter.name}
            >
              <a className={`clickable nav-link ${cellFilter.name === potentialFilter.name ? 'active' : ''}`} onClick={() => this.setFilter(potentialFilter)}>{potentialFilter.name}</a>
            </li>
          ))}
        </ul>
        <div>
          {imagesView}
        </div>
      </div>
    )
  }
}

export default DiffView



// WEBPACK FOOTER //
// ./src/routes/Images/components/DiffView.js